export default __webpack_public_path__ + "static/media/Subtract-1.caba6344.svg";